import { ITab } from "components/tabs/Tabs";
import { IItemList } from "components/core/Select";

export const SORT_OPTIONS: IItemList[] = [
  {
    label: "Trending",
    value: "trending"
  },
  {
    label: "Top",
    value: "top"
  },
  {
    label: "Latest",
    value: "new"
  },
];

export const SORT_TOP_OPTIONS: IItemList[] = [
  {
    label: "This week",
    value: "top7"
  },
  {
    label: "This month",
    value: "top28"
  },
  {
    label: "All Time",
    value: "best"
  },
];

export const MANAGE_TABS: ITab[] = [
  {
    value: "a",
    label: "All",
  },
  {
    value: "g",
    label: "GIFs",
  },
  {
    value: "i",
    label: "Images",
  },
];
